import { render, staticRenderFns } from "./main-entry.vue?vue&type=template&id=73f96240&scoped=true&"
import script from "./main-entry.vue?vue&type=script&lang=js&"
export * from "./main-entry.vue?vue&type=script&lang=js&"
import style0 from "./main-entry.vue?vue&type=style&index=0&id=73f96240&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f96240",
  null
  
)

export default component.exports